<template>
  <v-dialog
    v-model="active"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on }"/>
    </template>

    <v-card>
      <v-card-title
        class="title grey lighten-4"
        primary-title
      >
        Compartilhar Pasta
      </v-card-title>
      <v-card-text>
        <v-container
          class="fill-height"
        >
          <v-row
            class="ma-0 pt-4"
          >
            <v-combobox
              v-model="emailList"
              label="E-mails"
              multiple
              outlined
              chips
              deletable-chips
              :error-messages="emailListErrors"
            >
              <template v-slot:selection="data">
                <v-chip
                  :key="JSON.stringify(data.item)"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  :disabled="data.disabled"
                  @click:close="data.parent.selectItem(data.item)"
                >
                  <v-avatar
                    class="accent white--text"
                    left
                    v-text="data.item.slice(0, 1).toUpperCase()"
                  />
                  {{ data.item }}
                  <v-btn
                    icon
                    x-small
                    @click="data.parent.selectItem(data.item)"
                  >
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                </v-chip>
              </template>
            </v-combobox>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-btn
          color="accent"
          text
          @click="active = false"
        >
          Fechar
        </v-btn>
        <v-spacer/>
        <v-btn
          color="primary"
          @click="onShareProjectClick"
          :loading="isSharing"
        >
          Enviar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {validationMixin} from "vuelidate"
  import {required} from "vuelidate/lib/validators"
  import {every, filter, forEach} from "lodash/collection"
  import {PROCESSING_STATUS} from "../../helpers/processings/constants"
  import {generateProjectShare} from "../../api/api-project"
  import {DIALOG_TYPES, DialogOptions} from "../../helpers/dialogs"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"
  import {mapGetters} from "vuex"
  import {GET_PROCESSING_LIST} from "../../store/modules/processing"
  import {isEqual} from "lodash/lang"

  export default {
    name: "ProjectShareDialog",
    mixins: [validationMixin],
    props: {
      project: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      active: false,
      isSharing: false,

      emailList: [],
    }),
    validations() {
      return {
        emailList: {
          required,
          hasAnyEmailInvalid: () => this.multipleEmailValidation(),
        }
      }
    },
    methods: {
      onShareProjectClick() {
        this.$v.$touch()

        if (this.$v.$invalid) return

        if (!this.projectCanShare) {
          this.$notify(new NotificationOptions({
            message: "Só é possível compartilhar projetos onde todos os processamentos estejam finalizados",
            type: NOTIFICATION_TYPES.WARNING
          }))
          return
        }

        this.isSharing = true

        let payloadData = {
          lst_str_email: this.emailList,
          cd_project: this.project["id_project"],
        }

        const authToken = this.$apiAuth.getAuthToken()
        generateProjectShare(authToken, payloadData)
          .then(() => {
            this.$dialog(new DialogOptions({
              title: "Compartilhamento de projeto",
              content: "Será enviado um link de compartilhamento do projeto para os emails solicitados.",
              cancelText: "Entendi",
              type: DIALOG_TYPES.ALERT,
            }))
          })
          .finally(() => {
            this.active = false
            this.isSharing = false
          })

      },
      multipleEmailValidation() {
        const emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/

        let isValid = true
        forEach(this.emailList, email => {
          if (!emailRegex.test(email))
            isValid = false
        })
        return isValid
      },
    },
    computed: {
      emailListErrors() {
        const errors = []
        if (!this.$v.emailList.$dirty) return errors
        !this.$v.emailList.required && errors.push("Esse campo é obrigatório")
        !this.$v.emailList.hasAnyEmailInvalid && errors.push("Existe algum email inválido")
        return errors
      },
      projectCanShare() {
        if (!this._processingList) return false

        const processingList = filter(this._processingList, processing => isEqual(processing["cd_project"], this.project["id_project"]))
        return every(processingList, processing => isEqual(processing["ab_processing_status"], PROCESSING_STATUS.ENDED))
      },
      ...mapGetters({
        _processingList: GET_PROCESSING_LIST
      })
    },
  }
</script>

<style scoped>

</style>
